import React from "react";
import MenuFarolDeskMobile from "../../../components/gestao/MenuFarol/MenuDeskMobile";
import { Grid } from "@mui/material";
import { defaultRequest } from "../../../utils/functions";
import "react-datepicker/dist/react-datepicker.css";
import { useState, useEffect } from "react";
import "../Acessos/acessos.css";
import Row from "./RowDashOperacao";

export default function Atualizacoes() {
    const [dados, setDados] = useState(false);
    const route = "/dash-operacao";

    useEffect(() => {
        defaultRequest(route, {}).then(function (response) { console.log(response); setDados(response); }).catch((error) => { console.log(error.message); return; });
    }, []);

    return (
        <>
            <MenuFarolDeskMobile
                title={''}
                body={
                    <div className="card-total">
                        <div className="divider-pacote" />
                        {dados && (<>
                            <Grid container className="" >
                                <table>
                                    <thead>
                                        <tr className="header-tabela">
                                            <th className="th" >MARCA</th>
                                            <th className="th" >CANCELADO</th>
                                            <th className="th" >LINX</th>
                                            <th className="th" >SLA</th>
                                        </tr>
                                    </thead>
                                    <tbody> {dados && dados.map((iten) => { return <Row row={iten} />; })}
                                    </tbody>
                                </table>

                            </Grid>

                        </>)}

                    </div >
                }
            />
        </>
    );
}
